import { Link } from 'react-router-dom';
import './Header.scss';

const Header = () => (
    <header className='header container'>
        <Link to="/">
            <img 
                src='/logos/Making-Biscuits-Logo-SVG-Inverse.svg' 
                width={350}
                alt="Making Biscuits Collective"
            />
        </Link>
        <nav>
            <ul className="home-nav">
                <li><Link to="/about">Our Story</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/connect">Connect</Link></li>
            </ul>
        </nav>
    </header>
);

export default Header;